import { createTheme, type Shadows } from '@mui/material/styles';
import { components } from './components';
import { lightPalette } from './palette';
import { typography } from './typography';

// Soft, low-contrast elevation: menus and dialogs float, nothing else casts a shadow.
const shadow = (y: number, blur: number, alpha: number) =>
  `0 1px 2px rgba(16, 24, 40, 0.04), 0 ${y}px ${blur}px rgba(16, 24, 40, ${alpha})`;
const shadows = [
  'none',
  ...Array.from({ length: 24 }, (_, i) => shadow(2 + i, 6 + i * 2, Math.min(0.06 + i * 0.006, 0.16))),
] as Shadows;

export const theme = createTheme({
  cssVariables: true,
  palette: lightPalette,
  shape: { borderRadius: 8 },
  spacing: 8,
  shadows,
  typography,
  components,
});

export const LAYOUT = {
  navWidth: 256,
  railWidth: 72,
  topBarHeight: 60,
  assistantWidth: 440,
  contentMaxWidth: 1240,
} as const;
